import Accordion from 'react-bootstrap/Accordion'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/esm/Col'
import Container from 'react-bootstrap/esm/Container'
import Badge from 'react-bootstrap/Badge';
import Image from 'react-bootstrap/Image';
import Table from 'react-bootstrap/Table';

import '../utils/general.css';
import '../utils/experiences.css'

import enTranslations from '../locales/en.json';
import frTranslations from '../locales/fr.json';
import { useLanguage } from '../components/languageContext'; // Importez le hook useLanguage
import Seo from '../components/seo';

import MMlogo from '../assets/pictures/mm-logo.webp';
import Textmelogo from '../assets/pictures/textme.webp';
import Educationlogo from '../assets/pictures/education-logo.webp';
import Education from '../assets/pictures/education-photo.webp';
import Rushour from '../assets/pictures/rushour.webp';

const RUSHOUR_BACKEND_STACK = ['TypeScript', 'Node.js', 'DynamoDB', 'AWS'];
const RUSHOUR_FRONTEND_STACK = ['JavaScript', 'TypeScript', 'React', 'React Native'];
const FREELANCE_SHOWCASE_STACK = ['VueJs', 'React', 'Bootstrap', 'Tailwind CSS', 'Render', 'Vercel'];
const FREELANCE_BOTS_STACK = ['Python', 'Discord', 'MySQL'];
const FREELANCE_ECOMMERCE_STACK = ['Django', 'React', 'PostgreSQL', 'Docker', 'Docker Compose', 'Jenkins', 'Render'];
const TECH_BADGE_COLORS = ['blue', 'purple', 'teal', 'orange', 'green'];

function TechStack({ stack }) {
  return (
    <div className="mb-2">
      {stack.map((tech, index) => (
        <span
          key={tech}
          className={`ps-tech-badge ps-tech-badge-${TECH_BADGE_COLORS[index % TECH_BADGE_COLORS.length]}`}
        >
          {tech}
        </span>
      ))}
    </div>
  );
}

export default function Experiences() {
  const { language } = useLanguage();

  // Importez les traductions en fonction de la langue
  const translations = language === 'en' ? enTranslations : frTranslations;

  return (
    <Container className='ps-experiences vertical-center mb-5' fluid>
      <Seo title={translations.seo.experiences.title} description={translations.seo.experiences.description} />
      <Row className='ps-row'>
        <Col>
          <h1 className="ps-page-title mt-5 mb-4">{translations.experience.titre}</h1>
          <Accordion defaultActiveKey="0" className="">
            <Accordion.Item eventKey="0" className="sens-90">
              <Accordion.Header className=''>
                <Row className="" style={{ width: '100vw'}} >
                  <Col xs={10} className='d-flex flex-column '>
                    <h2 className='ps-job-title fw-bold'>
                      {translations.experience.rushour.title}
                    </h2>
                    <p className='fst-italic'>
                      {translations.since} 2024
                    </p>
                  </Col>
                  <Col xs={2} className='d-none d-sm-flex flex-column justify-content-center align-items-start gap-1'>
                    <Badge pill bg="success">{translations.in_prog}</Badge>
                    <Badge pill bg="info">{translations.experience.rushour.contract}</Badge>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className='custom-body'>
                <Image
                  src={Rushour}
                  fluid
                  loading="lazy"
                  className='rounded mx-auto d-block img-thumbnail mb-4'
                  alt="Rushour logo"
                />
                <p className='fw-lighter'>{translations.experience.rushour.intro}</p>

                <div className='ps-experience-highlight'>
                  <p className='ps-experience-highlight-title'>{translations.experience.rushour.backend_example_title}</p>
                  <p className='mb-0'>{translations.experience.rushour.backend_example}</p>
                </div>

                <Row className="mt-4">
                  <Col lg={6}>
                    <p className='mb-1 fw-bolder fs-5'>{translations.experience.rushour.backend_title}</p>
                    <TechStack stack={RUSHOUR_BACKEND_STACK} />
                    <ul className='ps-experience-list'>
                      <li>{translations.experience.rushour.backend1}</li>
                      <li>{translations.experience.rushour.backend2}</li>
                      <li>{translations.experience.rushour.backend3}</li>
                      <li>{translations.experience.rushour.backend4}</li>
                      <li>{translations.experience.rushour.backend5}</li>
                      <li>{translations.experience.rushour.backend6}</li>
                    </ul>
                  </Col>

                  <Col lg={6} className='mt-4 mt-lg-0'>
                    <p className='mb-1 fw-bolder fs-5'>{translations.experience.rushour.frontend_title}</p>
                    <TechStack stack={RUSHOUR_FRONTEND_STACK} />
                    <ul className='ps-experience-list'>
                      <li>{translations.experience.rushour.frontend1}</li>
                      <li>{translations.experience.rushour.frontend2}</li>
                      <li>{translations.experience.rushour.frontend3}</li>
                      <li>{translations.experience.rushour.frontend4}</li>
                      <li>{translations.experience.rushour.frontend5}</li>
                    </ul>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1" className="sens-80">
              <Accordion.Header className=''>
                <Row className="" style={{ width: '100vw'}} >
                  <Col xs={10} className='d-flex flex-column '>
                    <h2 className='ps-job-title fw-bold'>
                      {translations.experience.freelance_exp.title}
                    </h2>
                    <p className='fst-italic'>
                      {translations.during}: 2 {translations.year}s (2023 - 2025)
                    </p>
                  </Col>
                  <Col xs={2} className='d-none d-sm-flex justify-content-start align-items-center'>
                    <Badge pill bg="primary">{translations.done}</Badge>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className='custom-body'>
                <div className='d-flex justify-content-center align-items-center'>
                  <div className='base-cube'>
                    <div className="cube">
                      <div className="face front "></div>
                      <div className="face back "></div>
                      <div className="face left "></div>
                      <div className="face right "></div>
                      <div className="face top "></div>
                      <div className="face bottom "></div>
                    </div>
                  </div>
                </div>
                
                <div className="mt-3">
                  <p className='mb-0 fw-bolder fs-5'>{translations.experience.freelance_exp.exp1}</p>
                  <TechStack stack={FREELANCE_SHOWCASE_STACK} />
                  <p className='fw-lighter'>{translations.experience.freelance_exp.exp1_bis}</p>
                  <p className='fw-lighter'>{translations.experience.freelance_exp.exp1_ter}</p>
                </div>

                <div className="mt-5">
                  <p className='mb-0 fw-bolder fs-5'>{translations.experience.freelance_exp.exp2}</p>
                  <TechStack stack={FREELANCE_BOTS_STACK} />
                  <p className='mb-0'>{translations.experience.freelance_exp.exp2_bis}</p><br />
                  <p className='mb-0 fw-bolder'>{translations.experience.freelance_exp.exp2_bot_1}</p>
                  <p className=''>{translations.experience.freelance_exp.exp2_bot_1_1}</p>


                  <p className='mb-0 fw-bolder'>{translations.experience.freelance_exp.exp2_bot_2}</p>
                  <p className=''>{translations.experience.freelance_exp.exp2_bot_2_1}</p>

                  <p className='mb-0 fw-bolder'>{translations.experience.freelance_exp.exp2_bot_3}</p>
                  <p className=''>{translations.experience.freelance_exp.exp2_bot_3_1}</p>
                </div>

                <div className="mt-5">
                  <p className='mb-0 fw-bolder fs-5'>{translations.experience.freelance_exp.exp3}</p>
                  <TechStack stack={FREELANCE_ECOMMERCE_STACK} />
                  <p className='fw-lighter'>{translations.experience.freelance_exp.exp3_1}</p>

                  <p className='mb-0 fw-bolder'>{translations.experience.freelance_exp.exp3_2_1}</p>
                  <p className=''>{translations.experience.freelance_exp.exp3_2_2}</p>

                  <p className='mb-0 fw-bolder'>{translations.experience.freelance_exp.exp3_3_1}</p>
                  <p className=''>{translations.experience.freelance_exp.exp3_3_2}</p>

                  <p className='mb-0 fw-bolder'>{translations.experience.freelance_exp.exp3_4_1}</p>
                  <p className=''>{translations.experience.freelance_exp.exp3_4_2}</p>

                  <p className='fw-lighter'>{translations.experience.freelance_exp.exp_end}</p>
                </div>

                
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2" className="sens-70">
              <Accordion.Header>
                <Row style={{ width: '100vw'}} >
                  <Col xs={10} className='d-flex flex-column '>
                    <h2 className='ps-job-title fw-bold'>
                      {translations.experience.mm.title}
                    </h2>
                    <p className='fst-italic'>
                      {translations.during}: 1 {translations.year} (2023 - 2024)
                    </p>
                  </Col>
                  <Col xs={2} className='d-none d-sm-flex justify-content-start align-items-center'>
                    <Badge pill bg="primary">{translations.done}</Badge>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className='custom-body'>
                <Image
                  src={MMlogo}
                  fluid
                  loading="lazy"
                  className='rounded mx-auto d-block img-thumbnail mb-4'
                  alt="Logo MagicMakers"
                />
                <p className='fw-bold fs-5'>{translations.experience.mm.exp1}</p>
                <ul className='ps-experience-list'>
                  <li>{translations.experience.mm.exp2}</li>
                  <li>{translations.experience.mm.exp3}</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3" className="sens-60">
              <Accordion.Header>
                <Row style={{ width: '100vw'}} >
                  <Col xs={10} className='d-flex flex-column '>
                    <h2 className='ps-job-title fw-bold'>
                      {translations.experience.intership.title}
                    </h2>
                    <p className='fst-italic'>
                    {translations.during}: 6 {translations.month}s
                    </p>
                  </Col>
                  <Col xs={2} className='d-none d-sm-flex justify-content-start align-items-center'>
                    <Badge pill bg="primary">{translations.done}</Badge>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className='custom-body'>
                <Image
                  src={Textmelogo}
                  fluid
                  loading="lazy"
                  className='rounded mx-auto d-block img-thumbnail mb-4'
                  alt="Logo TextMe"
                />
                <p className='fw-bold fs-5'>{translations.experience.intership.info}</p>
                <ul className='ps-experience-list'>
                  <li>{translations.experience.intership.exp1}</li>
                  <li>{translations.experience.intership.exp2}</li>
                  <li>{translations.experience.intership.exp3}</li>
                  <li>{translations.experience.intership.exp4}</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4" className="sens-50">
              <Accordion.Header>
                <Row style={{ width: '100vw'}} >
                  <Col xs={10} className='d-flex flex-column '>
                    <h2 className='ps-job-title fw-bold'>
                      {translations.experience.teacher.title}
                    </h2>
                    <p className='fst-italic'>
                      {translations.during}: 2 {translations.year}s
                    </p>
                  </Col>
                  <Col xs={2} className='d-none d-sm-flex justify-content-start align-items-center'>
                    <Badge pill bg="primary">{translations.done}</Badge>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className='custom-body'>
                <Image
                  src={Educationlogo}
                  fluid
                  loading="lazy"
                  className='rounded mx-auto d-block img-thumbnail mb-4'
                  alt="Logo du Ministère de l'Éducation Nationale et de la Jeunesse"
                />
                <p className='fw-bold fs-5'>{translations.experience.teacher.info}</p>
                <ul className='ps-experience-list'>
                  <li>{translations.experience.teacher.exp1}</li>
                  <li>{translations.experience.teacher.exp2}</li>
                  <li>{translations.experience.teacher.exp3}</li>
                  <li>{translations.experience.teacher.exp4}</li>
                  <li>{translations.experience.teacher.exp5}</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5" className="sens-40">
              <Accordion.Header>
                <Row style={{ width: '100vw'}} >
                  <Col xs={10} className='d-flex flex-column '>
                    <h2 className='ps-job-title fw-bold'>
                      {translations.experience.edu_various.title}
                    </h2>
                    <p className='fst-italic'>
                      {translations.during}: 6 {translations.year}s
                    </p>
                  </Col>
                  <Col xs={2} className='d-none d-sm-flex justify-content-start align-items-center'>
                    <Badge pill bg="primary">{translations.done}</Badge>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className='custom-body'>
                <Image
                  src={Education}
                  fluid
                  loading="lazy"
                  className='rounded mx-auto d-block my-2 img-thumbnail'
                  alt="Picture by Kimberly Farmer"
                  title="Picture by Kimberly Farmer"
                />
                <Table striped bordered hover className="table-info" variant="dark">
                  <thead>
                    <tr className='text-lg-start text-center fs-4'>
                      <th>{translations.title}</th>
                      <th>{translations.time_spend}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{translations.experience.edu_various.exp1}</td>
                      <td>{translations.experience.edu_various.exp1_time} {translations.month}s</td>
                    </tr>
                    <tr>
                      <td>{translations.experience.edu_various.exp2}</td>
                      <td>{translations.experience.edu_various.exp2_time} {translations.month}s</td>
                    </tr>
                    <tr>
                      <td>{translations.experience.edu_various.exp3}</td>
                      <td>{translations.experience.edu_various.exp3_time} {translations.year}s</td>
                    </tr>
                    <tr>
                      <td>{translations.experience.edu_various.exp4}</td>
                      <td>{translations.experience.edu_various.exp4_time} {translations.year}s</td>
                    </tr>
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        
        </Col>
      </Row>

    </Container>
  )
}